import { SiteId } from '../types.js';
import GoodLifePlus from './good-life-plus.js';
import Rangers from './rangers.js';
import Saints from './saints.js';
const defaultSite = SiteId.GoodLifePlus;
export const themes = {
    [SiteId.GoodLifePlus]: GoodLifePlus,
    [SiteId.Rangers]: Rangers,
    [SiteId.Saints]: Saints,
};
export const getTheme = (siteId = defaultSite) => themes[siteId] ?? themes[defaultSite];
